import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { convertArrToObj } from 'lib/src/utils/generic';
import {
    fetchChallengesForCalendarRequest,
    fetchChallengesForCalendarSuccess,
    fetchChallengesForCalendarFailure,
    fetchChallengeGroupOptionsForCalendarRequest,
    fetchChallengeGroupOptionsForCalendarSuccess,
    fetchChallengeGroupOptionsForCalendarFailure,
    setCalendarFilterDataAction,
    FilterDataRequest,
    FilterData,
} from '@actions/calendar';
import {
    CalendarChallenge,
    CalendarChallengeGroupOption,
    CalendarOptionResponse,
} from 'src/types/shared/Challenge';
import dayjs from 'dayjs';

interface CalendarState {
    isFetching: boolean;
    fetchError: string | null;
    calendarChallenges: Record<number, CalendarChallenge>;
    myChallengeGroupOptions: CalendarChallengeGroupOption[];
    allChallengeGroupOptions: CalendarChallengeGroupOption[];
    calendarFilterData: FilterData;
}

const initialState: CalendarState = {
    isFetching: false,
    fetchError: null,
    calendarChallenges: {},
    myChallengeGroupOptions: [],
    allChallengeGroupOptions: [],
    calendarFilterData: {
        startDate: dayjs().startOf('month').toDate(),
        endDate: dayjs().startOf('month').add(59, 'days').toDate(),
        challengeGroupIDs: [-1],
    },
};

export default createReducer(initialState, {
    [fetchChallengesForCalendarRequest.type]: handleFetchRequest,
    [fetchChallengesForCalendarSuccess.type]: handleFetchChallengesForCalendarSuccess,
    [fetchChallengesForCalendarFailure.type]: handleFetchFailure,
    [fetchChallengeGroupOptionsForCalendarRequest.type]: handleFetchRequest,
    [fetchChallengeGroupOptionsForCalendarSuccess.type]: handleFetchChallengeGroupOptionsForCalendarSuccess,
    [fetchChallengeGroupOptionsForCalendarFailure.type]: handleFetchFailure,
    [setCalendarFilterDataAction.type]: handleSetCalendarFilterData,
});

function handleFetchRequest(state: CalendarState) {
    state.isFetching = true;
}

function handleFetchFailure(state: CalendarState, action: PayloadAction<string>) {
    state.fetchError = action.payload;
    state.isFetching = false;
}

function handleFetchChallengesForCalendarSuccess(
    state: CalendarState,
    action: PayloadAction<CalendarChallenge[]>,
) {
    state.calendarChallenges = convertArrToObj(action.payload);
    state.isFetching = false;
}

function handleFetchChallengeGroupOptionsForCalendarSuccess(
    state: CalendarState,
    action: PayloadAction<CalendarOptionResponse>,
) {
    const { allChallengeGroups, myChallengeGroups } = action.payload;
    state.myChallengeGroupOptions = myChallengeGroups;
    state.allChallengeGroupOptions = allChallengeGroups;
    state.isFetching = false;
}

function handleSetCalendarFilterData(
    state: CalendarState,
    action: PayloadAction<FilterDataRequest>,
) {
    state.calendarFilterData = { ...state.calendarFilterData, ...action.payload };
}
